import { SimpleSocialLanding } from "@/components/SimpleSocialLanding";
import { BRAND_PERSON_NAME } from "@/lib/brandConfig";

const TikTok = () => (
  <SimpleSocialLanding
    seoPageKey="tiktok"
    i18nPrefix="simplePages.tiktok"
    imageAlt={`${BRAND_PERSON_NAME} - TikTok creator profile photo`}
  />
);

export default TikTok;
